var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeRepoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.29,12.71a1,1,0,0,1,0-1.42l4-4A1,1,0,1,1,9.71,8.71L6.41,12l2.8,2.79,5.58-5.58-.5-.5a1,1,0,1,1,1.42-1.42l.5.5L20,4,18.17,2.17A4,4,0,0,0,15.34,1H3A2,2,0,0,0,1,3V21a2,2,0,0,0,.59,1.41l6.2-6.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3,23H21a2,2,0,0,0,2-2V8.66a4,4,0,0,0-1.17-2.83L20,4,16.21,7.79l3.5,3.5a1,1,0,0,1,0,1.42l-4,4a1,1,0,0,1-1.42-1.42L17.59,12l-2.8-2.79L9.21,14.79l.5.5a1,1,0,0,1-1.42,1.42l-.5-.5-6.2,6.2A2,2,0,0,0,3,23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeRepoActive);
export default __webpack_public_path__ + "static/media/code-repo-active.31070a3687fd222da7bad0d7d3f2f1a5.svg";
export { ForwardRef as ReactComponent };